import React from 'react'
import { useSelector } from 'react-redux'
import Typography from 'transfix-ui/core/Typography'
import { useGetShipperAccessorialPolicies } from 'apps/marketplace/apiTypes/shipperAccessorials'
import AccessorialRowDetails from 'apps/marketplace/pages/shippers/components/ShipperAccessorials/AccessorialRowDetails'
import { Card, Spinner } from 'transfix-ui'
import { selectShipment } from '../utils/hooks/selectors'
import DetentionShipperAccessorial from './DetentionShipperAccessorial'

const DetentionShipperAccessorialCard: React.FC = () => {
  const shipment = useSelector(selectShipment)

  const { equipment, info } = shipment || {}
  const { shipperId, shipperName } = info || {}

  const { parentId: equipmentId } = equipment || {}

  const { data, loading } = useGetShipperAccessorialPolicies({ shipperId: Number(shipperId) })
  const accessorials = data?.shipperApplicationAccessorialPolicies

  const accessorial = accessorials?.find(
    a => a.shipmentAccessorialName.includes(`Detention Fee`) && a.equipmentId === equipmentId
  )
  return (
    <div className='col-xs-12 col-md-12'>
      <Card title={`${shipperName} Shipper Accessorial Policy`}>
        <div>
          {loading && <Spinner />}
          {accessorial ? (
            <div>
              <DetentionShipperAccessorial accessorial={accessorial} />
              <AccessorialRowDetails accessorial={accessorial} />
            </div>
          ) : (
            <Typography variant='h3' align='center'>
              No custom accessorial rates have been added for {shipperName}
            </Typography>
          )}
        </div>
      </Card>
    </div>
  )
}

export default DetentionShipperAccessorialCard
